/** One-line status for PMI/VDD operational mini-cards (Figma PMIOperationalRow). */

export function buildOperationalSummaries(model) {
    const { delivery, observationCount, observationsView } = model;
    const obsCount = observationsView?.count ?? observationCount ?? 0;

    return {
        tasks: summarizeTasks(delivery?.tasks),
        raid: summarizeRaid(delivery?.raid),
        actionLog: summarizeActionLog(delivery?.actionLog),
        observations: obsCount > 0 ? `${obsCount} observation${obsCount === 1 ? '' : 's'}` : 'No observations yet',
    };
}

function summarizeTasks(tasks) {
    if (!tasks || tasks.open === 0) return 'No tasks yet';
    return tasks.lines[0];
}

function summarizeRaid(raid) {
    if (!raid?.lines?.[0]) return 'No RAID items';
    if (raid.lines[0].startsWith('0 active')) return 'No RAID items';
    return raid.lines[0];
}

function summarizeActionLog(actionLog) {
    if (!actionLog?.lines?.[0]) return 'No actions';
    if (actionLog.lines[0].startsWith('0 open')) return 'No actions';
    return actionLog.lines[0];
}
